// FetchOffersOverview POST /api/2.0/offers/fetch_offers_overview
import { api } from "services/api/service";
import { API_FETCH_ACTIVE_OFFERS, API_FETCH_USER_OFFERS, API_REDEEM_OFFERS } from "constants/api";
import type { ApiResponse } from "services/api/types";

export const getActiveOffers = async (): Promise<ApiResponse<any>> => {
	return (await api()).post(API_FETCH_ACTIVE_OFFERS, {
		exclude_sub_category: ["cagfunded"]
	});
};

interface Payload {
	card_no?: string;
}

interface VoucherType {
	code: string;
	offer_id: string;
}
interface RedeemOffersPayload {
	remarks: string;
	card_no: string;
	receipt: string;
	redemption_voucher_lists: VoucherType[];
}
export const fetchUserOffer = async (payload: Payload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_FETCH_USER_OFFERS, payload);
};

export const redeemOffers = async (payload: RedeemOffersPayload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_REDEEM_OFFERS, payload);
};
